module.exports = __webpack_public_path__ + "static/media/image (69).34eeed38.jpg";